import Vue from 'vue';
import { mapGetters } from 'vuex';
import HeadingBar from './HeadingBar.vue';
import SiteSidebar from './SiteSidebar.vue';
export default Vue.extend({
    components: { HeadingBar, SiteSidebar },
    metaInfo() {
        return {
            title: this.currentSite ? `${this.currentSite.site_name} - Kapiche` : 'Kapiche'
        };
    },
    data: () => {
        return {
            sideBarCollapse: false
        };
    },
    computed: {
        ...mapGetters(['currentSite'])
    },
    methods: {
        toggleCollapse(value) {
            this.sideBarCollapse = value;
        }
    }
});
